<template>
  <div>
    <div class="row">
      <div class="input-group col-sm-4">
        <label style="font-size: 0.8rem; color: #666" >
          Nome
        </label>
        <input
          v-model="body.name"
          required
          class="input borderInput"
          ref="nome"
        />
      </div>
      <div class="input-group col-sm-4">
        <label style="font-size: 0.8rem; color: #666" >
          Data
        </label>

        <input
          v-model="body.data"
          type="date"
          required
          class="input borderInput"
          ref="nome"
        />
      </div>
      <div
        class="input-group col-sm-4"
        style="display: flex; flex-direction: column"
      >
        <label style="font-size: 0.8rem; color: #666" >
          Iniciar às.
        </label>

        <b-form-select
          style="width: 100%;border-radius: 5px"
          v-model="body.hour"
          :options="optionsHours"
          size="sm"
        ></b-form-select>
      </div>

      <div class="col-sm-6 mt-2">
        <div style="width: 100%">
          <span style="font-size: 0.8rem; color: #666">Mensagem</span>
          <textarea
            class="inputTextArea form-control"
            style="font-size: 0.8rem"
            rows="7"
            maxlength="500"
            v-model="body.message"
          />
        </div>
        <p style="color: #817c7c">
            Qtd de caracteres: {{ String(body.message).length }} / 500
        </p>
      </div>

      <div class="col-sm-6 mt-3">
        <p style="font-size: 0.8rem; color: #666">Destinatários</p>
        <b-form-group style="margin-top:20px;margin-left:-20px;margin-bottom:0px;" label="" v-slot="{ ariaDescribedby }" v-if="!body.id">
          <b-form-radio
            v-model="selected"
            :aria-describedby="ariaDescribedby"
            name="some-radios"
            value="A"
            style="font-size: 0.8rem"
            >Importar clientes</b-form-radio
          >
          <b-form-radio
            v-model="selected"
            :aria-describedby="ariaDescribedby"
            name="some-radios"
            value="B"
            style="font-size: 0.8rem"
            >Selecionar clientes</b-form-radio
          >
        </b-form-group>
        <div v-if="selected === 'A'">
          <p style="font-size: 0.8rem; color: #666">Destinatários</p>
          <div class="border p-2 rounded">
            <div>
              <p style="font-size: 0.8rem; color: #666">Importar clientes</p>
              <input
                type="file"
                accept=".csv"
                @change="onFileChanged($event)"
              />
            </div>
          </div>
        </div>

        <div class="border p-2 rounded mt-2" v-if="selected === 'B'">
          <div>
            <p style="font-size: 0.8rem; color: #666">Selecionar clientes</p>
            <button
              class="btn btn-sm btn-dark"
              style="font-size: 0.8rem"
              @click="()=>{
                nextPage('selectClientes')
                body.contacts = [];
              }"
            >
              Pesquisar clientes
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 mt-4"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <button
          class="btn btn-sm"
          style="background-color: #0051a9; color: #fff; font-size: 0.8rem"
          @click="nextPage('listCampanha')"
        >
          Voltar
        </button>
        <button
          class="btn btn-sm"
          style="background-color: #0051a9; color: #fff; font-size: 0.8rem"
          @click="handle"
        >
          Próximo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import uniqby from "lodash.uniqby";
import Joi from "joi";

export default {
  props: {
    nextPage: {
      type: Function,
    },
    body: {
      type: Object,
    },
    umvalor: {
      type: Number,
    },
  },
  data() {
    return {
      contacts: [],
      selected: "",
      optionsHours: [
        { value: "01:00", text: "01:00" },
        { value: "02:00", text: "02:00" },
        { value: "03:00", text: "03:00" },
        { value: "04:00", text: "04:00" },
        { value: "05:00", text: "05:00" },
        { value: "06:00", text: "06:00" },
        { value: "07:00", text: "07:00" },
        { value: "08:00", text: "08:00" },
        { value: "08:00", text: "08:00" },
        { value: "09:00", text: "09:00" },
        { value: "10:00", text: "10:00" },
        { value: "11:00", text: "11:00" },
        { value: "12:00", text: "12:00" },
        { value: "13:00", text: "13:00" },
        { value: "14:00", text: "14:00" },
        { value: "15:00", text: "15:00" },
        { value: "16:00", text: "16:00" },
        { value: "17:00", text: "17:00" },
        { value: "18:00", text: "18:00" },
        { value: "19:00", text: "19:00" },
        { value: "20:00", text: "20:00" },
        { value: "21:00", text: "21:00" },
        { value: "22:00", text: "22:00" },
        { value: "23:00", text: "23:00" },
        { value: "24:00", text: "24:00" },
      ],
    };
  },

  mounted() {
    this.selected = this.body.contacts.find((e) => !!e.id) ? "B" : "A";
  },
  methods: {
    onFileChanged(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split("\n");
        const data = lines.map((line) => line.split(","));
        const contacts = data
          .slice(1)
          .map((row) => {
            if (row.length === 1) {
              return null;
            }
            return {
              name: row[0],
              celular: row[1],
            };
          })
          .filter((e) => e !== null);

        this.body.contacts = uniqby(
          [...this.body.contacts, ...contacts],
          "celular"
        );
      };

      reader.readAsText(file);
    },
    handle() {
      const schema = Joi.object({
        name: Joi.string().required().messages({
          "string.empty": "O campo nome é obrigatório",
        }),
        data: Joi.date().required().messages({
          "date.base": "O campo data é obrigatório",
        }),
        hour: Joi.string().required().messages({
          "string.empty": "O campo hora é obrigatório",
        }),
        message: Joi.string().required().messages({
          "string.empty": "O campo mensagem é obrigatório",
        }),
        contacts: Joi.array()
          .items(
            Joi.object({
              id: Joi.string().allow(null),
              name: Joi.string().required(),
              celular: Joi.string().required(),
            })
          )
          .min(1)
          .messages({
            "array.min": "Selecione pelo menos um contato",
          }),
      });
      const { error } = schema.validate(this.body, {
        allowUnknown: true,
      });

      if (error) {
        return this.$toast.open({
          message: error.details[0].message,
          type: "info",
        });
      }

      this.nextPage("previewMarketing");
    },
  },
};
</script>

<style scoped>
p {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.inputDisabled {
  background-color: #fafafa;
  pointer-events: none;
  color: #949290 !important;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}


</style>